import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './routes/home/home.comp';
import ThisWeek from './routes/thisWeek/thisWeek.comp';
import ChallengeDetails from './components/challengeDetails/challengeDetails.comp';
import LandingPage from './routes/landingPage/landingPage.comp';
import SignOut from './routes/signOut/signOut.comp';
import SignIn from './routes/signIn/signIn.comp';
import NextWeek from './routes/nextWeek/nextWeek.comp';
import AcceptedChallengeDetails from './components/acceptedChallengeDetails/acceptedChallengeDetails.comp';
import Today from './routes/today/today.comp';
import Create from './components/create/create.comp';
import Settings from './components/settings/settings.comp';
import CurrentChallenges from './components/currentChallenges/currentChallenges.comp';
import MyChallenges from './components/mychallenges/myChallenges.comp';
import About from './routes/about/about.comp';
import DoneChallenges from './components/doneChallenges/doneChallenges.comp';
import ForgotPassword from './components/forgotPassword/forgotPassword.comp';
import TermsAndConditions from './routes/footerRoutes/termsAndConditions.comp';
import Privacy from './routes/footerRoutes/privacy.comp';
import Contact from './routes/footerRoutes/contact.comp';
import Copyright from './routes/footerRoutes/copyright.comp';
import Careers from './routes/footerRoutes/careers.comp';
import Channel from './components/channel/channel.comp';
import Page from './components/page/page.comp';

function ReactApp() {

  return (
    <div className="App">
      <Routes>
        <Route path="/reach" element={<LandingPage/>} />
        <Route path="/" element={<Home />} />
        <Route path="/challenge" element={<ChallengeDetails />} />
        <Route path="/challenge/:linkID" element={<ChallengeDetails />} />
        <Route path="/channel/:linkID" element={<Channel />} />
        <Route path="/page/:linkID" element={<Page />} />
        <Route path="/acceptedChallenge" element={<AcceptedChallengeDetails />} />
        <Route path="/today" element={<Today />} />
        <Route path="/done" element={<DoneChallenges />} />
        <Route path="/create" element={<Create />} />
        <Route path="/currentchallenges" element={<CurrentChallenges />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/about" element={<About />} />
        <Route path="/mychallenges" element={<MyChallenges />} />
        <Route path="/thisWeek" element={<ThisWeek />} />
        <Route path="/nextWeek" element={<NextWeek/>} />
        <Route path="/signOut" element={<SignOut />} />
        <Route path="/signIn" element={<SignIn />} />

        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/termsAndConditions" element={<TermsAndConditions />} />

        <Route path="/copyright" element={<Copyright />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </div>
  );
}

export default ReactApp;